<template>
        <div class="wrapper">    
  
                <img class="car_image" :src="CarImg">

            <div class="pt-3 pl-2">
                <small>{{CarMotorDescription}}   </small>
                <h5 class="title">{{CarModel}}   {{CarMotor}}    {{CarYear}} </h5>
                <div class="excluir" @click='RemoveGarage(garageId)'>
                <svg viewBox="0 0 24 24"  role="presentation" id="product-delete-button" class="removeGarage" style="width: 24px; height: 24px;"><path d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z" style="fill: rgb(153, 153, 153);"></path></svg>
                <small>Excluir </small>
                </div>


            </div>

        </div>

</template>

<script>
    export default {
        props: {
            CarImg: {
                type: String,
            },
            CarModel: {
                type: String,
            },
            CarMotor: {
                type: String,
            },
            CarYear: {
                type: [String, Number],
            },
            CarMotorDescription: {
                type: String,
            },
            CarId: {
                type:Number
            },
            RemoveGarage:{
                type:Function
            }
        },
        computed: {
            garageId() {
                return localStorage.getItem('garage_selected')
            }
        },
    }
</script>

<style lang="css" scoped>
.wrapper{
    display:flex;
    flex-direction: row;
}

.div-title {
    width:30%;
}

.title{
    color:var(--main-red-black);
}

.car_image {
    width: 25%;
    height: 5rem;
    vertical-align: middle;
    border-style: none;
    -o-object-fit:contain;
    object-fit: contain;
    background: transparent;
    padding-top:3%;
}


</style>